/*
  Corestride bundle picker (snippets/cs-bundle.liquid). Each sleeve of a Buy 2 / Buy 3 bundle has its own color and
  size. While the buyer has not touched a sleeve's selects, they follow the main variant picker. On add to cart:
  - every sleeve on the main variant: Dawn's product form adds it as usual (the checked radio is the quantity);
  - mixed sleeves: this script adds one cart line per variant with /cart/add.js, then hands the response to Dawn's
    cart drawer exactly like Dawn's own product form does.
  Offer (Nathan Miller's BOGO, chosen by Gab on 2026-10-18): Buy 1 | Buy 2, Get 1 Free (3) | Buy 3, Get 2 Free (5).
  The automatic "buy X get Y" discounts count every variant of the product, so mixed bundles get the same price.
  The checked tier also drives Dawn's price block, the add to cart label and the mobile sticky bar, so the price the
  buyer sees always matches what the cart will charge.
  Copy (English / French) comes from window.csStrings, set in sections/cs-brand.liquid.
*/
(() => {
  const root = document.querySelector('.cs-bundle');
  if (!root) return;
  const form = document.getElementById(root.dataset.form);
  if (!form) return;
  const S = window.csStrings || {};
  const variants = JSON.parse(root.querySelector('.cs-bundle__variants').textContent);
  const mainId = () => Number(form.querySelector('input[name="id"]').value);
  const byId = (id) => variants.find((v) => v.id === id);
  const byOptions = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));

  // sleeve selects follow the main picker until the buyer changes that sleeve
  function syncUntouched() {
    const main = byId(mainId());
    if (!main) return;
    root.querySelectorAll('.cs-unit:not([data-touched])').forEach((unit) => {
      unit.querySelectorAll('.cs-unit__select').forEach((select) => {
        select.value = main.options[Number(select.dataset.option)];
      });
    });
  }
  root.addEventListener('change', (event) => {
    const unit = event.target.closest('.cs-unit');
    if (unit) unit.dataset.touched = '';
  });
  form.addEventListener('change', () => setTimeout(syncUntouched, 0));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(syncUntouched, 0));
  }
  syncUntouched();

  // prices of the checked tier: sleeves -> sleeves paid for (the free ones come off at 100%)
  const PAID = { 1: 1, 3: 2, 5: 3 };
  const unit = Number(root.dataset.unit);
  const sectionId = root.dataset.section;
  const subtotal = root.querySelector('[data-subtotal]');
  const saveLine = root.querySelector('[data-save]');
  const saveAmount = root.querySelector('[data-save-amount]');
  const money = (cents) => '$' + (cents / 100).toFixed(2);
  const fill = (text, vars) => String(text || '').replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));
  const tier = () => {
    const qty = Number(root.querySelector('.cs-tier input:checked')?.value || 1);
    const total = unit * (PAID[qty] || qty);
    return { qty, total, full: unit * qty, saved: unit * qty - total };
  };

  // Dawn's price block shows one sleeve; for a bundle, show the bundle total in its place (Dawn re-renders the block
  // on every variant change, so this is repainted after each one)
  function paintPrice() {
    const t = tier();
    const block = document.getElementById(`price-${sectionId}`);
    if (block) {
      const code = (block.querySelector('.price-item--regular')?.textContent.trim().match(/\s([A-Z]{3})$/) || [])[1];
      const withCode = (cents) => money(cents) + (code ? ` ${code}` : '');
      let live = block.querySelector('.cs-price-live');
      if (t.qty > 1) {
        const html = `<span class="cs-price-live__now">${withCode(t.total)}</span><s>${withCode(t.full)}</s>`
          + `<span class="cs-price-live__save">${fill(S.save, { price: money(t.saved) })}</span>`;
        if (!live) {
          live = document.createElement('div');
          live.className = 'cs-price-live';
          block.prepend(live);
        }
        if (live.innerHTML !== html) live.innerHTML = html;
        block.classList.add('cs-price--bundle');
      } else {
        live?.remove();
        block.classList.remove('cs-price--bundle');
      }
    }
    // the add to cart label carries the total, like the Atlas buy box
    const button = form.querySelector('[type="submit"]');
    const label = button?.querySelector('span');
    const base = window.variantStrings?.addToCart;
    if (label && base && !button.disabled) {
      const text = `${base} · ${money(t.total)}`;
      if (label.textContent.trim() !== text) label.textContent = text;
    }
    const sticky = document.querySelector('.cs-sticky__price');
    if (sticky) sticky.textContent = money(t.total);
    if (subtotal) subtotal.textContent = money(t.total);
    if (saveLine && saveAmount) {
      saveLine.hidden = t.saved <= 0;
      saveAmount.textContent = money(t.saved);
    }
  }
  root.addEventListener('change', paintPrice);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(paintPrice, 0));
  }
  // Dawn swaps the price block and resets the button text after its own fetches; repaint whenever that happens
  const watched = [document.getElementById(`price-${sectionId}`), form.querySelector('[type="submit"]')].filter(Boolean);
  const watch = () => watched.forEach((node) => observer.observe(node, { childList: true, subtree: true, characterData: true }));
  const observer = new MutationObserver(() => {
    observer.disconnect();
    paintPrice();
    watch();
  });
  paintPrice();
  watch();

  // delivery window from the shipping policy (8-15 business days from the order), shown as real dates
  const eta = root.querySelector('[data-eta]');
  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days -= 1;
    }
    return d;
  };
  if (eta) {
    const fmt = (d) => d.toLocaleDateString(S.dateLocale || 'en-CA', { month: 'short', day: 'numeric' });
    const now = new Date();
    eta.textContent = (S.arrives || 'arrives {from} – {to}')
      .replace('{from}', fmt(addBusinessDays(now, 8)))
      .replace('{to}', fmt(addBusinessDays(now, 15)));
  }

  // the sleeves of the checked tier, as variant ids (null = an option combination that does not exist)
  function chosenIds() {
    const tier = root.querySelector('.cs-tier:has(input:checked)');
    if (!tier) return [];
    const units = tier.querySelectorAll('.cs-unit');
    if (!units.length) return [mainId()];
    return [...units].map((unit) => {
      const opts = [...unit.querySelectorAll('.cs-unit__select')].map((s) => s.value);
      const v = byOptions(opts);
      return v ? v.id : null;
    });
  }

  function showError(message) {
    const wrapper = form.closest('product-info, .product__info-wrapper, section')?.querySelector('.product-form__error-message-wrapper');
    const text = wrapper?.querySelector('.product-form__error-message');
    if (wrapper && text) {
      text.textContent = message;
      wrapper.removeAttribute('hidden');
    } else {
      window.alert(message);
    }
  }

  // capture phase on document runs before Dawn's submit handler on the form, so a mixed bundle never reaches it
  document.addEventListener(
    'submit',
    async (event) => {
      if (event.target !== form) return;
      const ids = chosenIds();
      if (ids.length < 2 || ids.every((id) => id === mainId())) return; // Dawn handles it
      event.preventDefault();
      event.stopImmediatePropagation();
      if (ids.includes(null)) return showError(S.errorCombo);

      const counts = ids.reduce((acc, id) => acc.set(id, (acc.get(id) || 0) + 1), new Map());
      const button = form.querySelector('[type="submit"]');
      button?.setAttribute('aria-disabled', 'true');
      button?.classList.add('loading');
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [...counts].map(([id, quantity]) => ({ id, quantity })),
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        });
        const state = await response.json();
        if (state.status) return showError(state.description || state.message || S.errorAdd);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cs-bundle', productVariantId: ids[0], cartData: state });
        }
        const drawer = document.querySelector('cart-drawer');
        if (drawer && state.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ ...state, id: ids[0] });
        } else {
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        }
      } catch (error) {
        showError(S.errorAdd);
      } finally {
        button?.removeAttribute('aria-disabled');
        button?.classList.remove('loading');
      }
    },
    true
  );
})();
